import Axios from "axios";
import ApiUtils from "../utils/api_utils";

const ReportSM = {
  state: 0,
  reducers: {},
  effects: () => ({
    /**
     * submit feed create post
     */
    async submitCreateReport(payload, rootState) {
      let result;
      const payloadFormData = new FormData();
      payloadFormData.append("subject", payload.title);
      payloadFormData.append("description", payload.description);
      payloadFormData.append(
        "is_anonymous",
        payload.anonym == 1 ? true : false
      );
      let x = 0;
      if (payload.img != "" || payload.img2 != "" || payload.img3 != "") {
        payloadFormData.append("document_type", 0);
        if (payload.img != "") {
          payloadFormData.append("documents[" + x + "]file", payload.img);
          x++;
        }
        if (payload.img2 != "") {
          payloadFormData.append("documents[" + x + "]file", payload.img2);
          x++;
        }
        if (payload.img3 != "") {
          payloadFormData.append("documents[" + x + "]file", payload.img3);
          x++;
        }
      }
      if (payload.video) {
        payloadFormData.append("document_type", 1);
        payloadFormData.append("documents[" + x + "]file", payload.video);
        x++;
      }
      if (payload.file != "") {
        payloadFormData.append("document_type", 2);
        payloadFormData.append("documents[" + x + "]file", payload.file);
        x++;
      }

      await Axios.post(
        `https://${ApiUtils.authority}/report_story/api/submit/`,
        payloadFormData,
        {
          headers: ApiUtils.getHeader({
            token: rootState.LoginSM.token,
          }),
          withCredentials: false,
        }
      )
        .then((response) => {
          result = {
            status: 200,
            message: "success",
            data: response.data,
          };
        })
        .catch((error) => {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
  }),
};

export default ReportSM;
